import React from 'react';
import ExportInvoicePdfsItem from '../../../Domain/ExportInvoicePdfsItem';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import ClientInvoiceService from '../../../Services/ClientInvoiceService';

export default class ExportPdfsWindowDescription extends React.Component {
  static titleForEdit = 'Export Batch';
  static finishButtonLabel = 'Start Export';
  static itemType = ExportInvoicePdfsItem;
  static serviceFunction = ClientInvoiceService.ExportInvoicePdfs;
  static waitForServiceFunction = () => false;

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'LatestVersion',
          label: 'Export Mode',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: ExportPdfsWindowDescription.getExportOptions(),
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
      ],
    },
  ];

  static getExportOptions() {
    return [
      { value: null, label: '' },
      { value: 'false', label: 'Finalized Invoices' },
      { value: 'true', label: 'Latest Invoices' },
    ];
  }
}
